module.exports = __webpack_public_path__ + "img/chuanbofenxi.072e30c1.png";